// eslint-disable-next-line import/prefer-default-export
export const USER_LOGOUT = 'USER_LOGOUT';
export const LOAD_USER = 'LOAD_USER';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const OPEN_VIEW_PROFILE_MODAL = 'OPEN_VIEW_PROFILE_MODAL';
export const CLOSE_VIEW_PROFILE_MODAL = 'CLOSE_VIEW_PROFILE_MODAL';
